import type { ReactNode } from 'react'

import { useState } from 'react'

interface AccordionItemProps {
    question: string
    answer: ReactNode
    defaultOpen?: boolean
}

export function AccordionItem({ question, answer, defaultOpen = false }: AccordionItemProps) {
    const [open, setOpen] = useState(defaultOpen)

    return (
        <div className='accordion'>
            <button
                type='button'
                className='accordion-header'
                aria-expanded={open}
                onClick={() => setOpen((value) => !value)}
                style={{
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    cursor: 'none',
                    display: 'flex',
                    textAlign: 'left'
                }}
            >
                <div className='accordion-title'>
                    <h3 className='accordion-title-text'>{question}</h3>
                </div>
                <div className='accordion-icon-container'>
                    <img
                        src='/images/Plus-Black.svg'
                        alt=''
                        className='accordion-icon'
                        style={{
                            transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
                            transition: 'transform 0.35s ease'
                        }}
                    />
                </div>
            </button>
            <div
                className='accordion-body'
                style={{
                    display: 'grid',
                    gridTemplateRows: open ? '1fr' : '0fr',
                    transition: 'grid-template-rows 0.45s ease'
                }}
            >
                <div style={{ overflow: 'hidden', minHeight: 0 }}>
                    <div className='accordion-body-content'>{answer}</div>
                </div>
            </div>
        </div>
    )
}
